export default __webpack_public_path__ + "229f4472b07414030884d69a4c584c4a.mp4";